import { ApolloProvider } from '@apollo/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { GlobalStyles } from '@podiumhq/podium-ui';
import { ThemeProvider } from '@podiumhq/design-system';

import Header from './features/Header/Header';
import Authorization from './components/Authorization/Authorization';
import MainRoutes from './components/MainRoutes';
import Toast from './components/Toast/Toast';
import { client } from './config/palantirClient';
import { configureRootStore } from './state/store';
import AmplitudeTracking from './components/AmplitudeTracking/AmplitudeTracking';
import useScript from './hooks/useScript';
import env from './lib/env';

const store = configureRootStore();

const Styles = GlobalStyles('');

export default function App() {
  useScript(env.REACT_APP_EXTERNAL_STATUS_URL, 'html');

  return (
    <ThemeProvider>
      <Provider store={store}>
        <ApolloProvider client={client}>
          <BrowserRouter>
            <Authorization>
              <Styles />
              <Toast.Component />
              <Header />
              <MainRoutes />
            </Authorization>
          </BrowserRouter>
          <AmplitudeTracking />
        </ApolloProvider>
      </Provider>
    </ThemeProvider>
  );
}
